import Vue from 'vue'
import { scrollBoard, loading } from '@jiaminghi/data-view'
import fullScreenContainer from '@/components/fullScreenContainer'
Vue.use(fullScreenContainer)
Vue.use(scrollBoard)
Vue.use(loading)